import { defer } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { getReturnsSimulationInfo } from "./common/service";

export function returnsSimulationLoader() {
  return defer({
    coreData: resolveLoaderResult(getReturnsSimulationInfo()),
  });
}
